module.exports = __webpack_public_path__ + "img/40.0c2d84cd.png";